/**
 * Removes query parameters from the URL hash (e.g., "#/page?foo=1" → "#/page").
 */
export function removeHashQuery(): void {
  const hash = window.location.hash;
  if (hash) {
    const cleanHash = hash.split('?')[0];
    window.history.replaceState({}, '', window.location.pathname + cleanHash);
  }
}
